/**
 * The CurrencySettings static object represents settings for the currency data type.
 * It provides digits for a specific currency and the default scale.
 */
var Customizing = {};

/**
 * Update the default settings with customization.
 *
 * @param {object} oConfig Configuration object that is used to specify the customization
 * @param {object} [oConfig.currency] Custom settings object that will be used for defining currency digits
 * @param {object} [oConfig.unit] Map of units with their corresponding scale
 * @param {object} [oConfig.timezone] Map of IANA timezone IDs with their corresponding translated text
 *
 * @public
 * @static
 */
Customizing.update = function(oConfig) {
	var sKey, iScale;

	/* Update currency scale with custom currencies */
	if (oConfig.currency) {

		/*
		 * If custom currencies contain a DEFAULT value
		 * we clear the CLDR settings to avoid a fallback
		 * to scale settings from CLDR.
		 */
		if (oConfig.currency.DEFAULT && typeof oConfig.currency.DEFAULT.scale === "number") {
			Customizing.CURRENCY = {};
		}

		for (sKey in oConfig.currency) {
			Customizing.CURRENCY[sKey] = iScale = oConfig.currency[sKey].scale;

			/* Determine MAX_CURRENCY_SCALE */
			if (iScale > Customizing.MAX_CURRENCY_SCALE) {
				Customizing.MAX_CURRENCY_SCALE = iScale;
			}
		}
	}

	if (oConfig.unit) {
		for (sKey in oConfig.unit) {
			Customizing.UNIT[sKey] = oConfig.unit[sKey].scale;
		}
	}

	if (oConfig.timezone) {
		Object.assign(Customizing.TIMEZONE, oConfig.timezone);
	}
};

Customizing.getScaleForCurrency = function(sCurrencyCode) {
	var iScale;

	iScale = Customizing.CURRENCY[sCurrencyCode];

	/* If the currency uses the default scale */
	if (typeof iScale !== "number") {
		iScale = Customizing.CURRENCY.DEFAULT;
	}

	return iScale;
};

Customizing.getScaleForUnit = function(sUnit) {
	return Customizing.UNIT[sUnit];
};

/**
 * Returns the translated timezone text for a given IANA timezone ID.
 * If no translation is available, the ID is returned.
 *
 * @param {string} sTimezone IANA timezone ID
 * @returns {string} Translated timezone text or IANA ID if no translation is available
 */
Customizing.getTimezoneTranslation = function(sTimezone) {
	return Customizing.TIMEZONE[sTimezone] || sTimezone;
};

/**
 * Defines the display default scale that is used for alignment. This has no effect on the technical scale of currency
 * values. It is only used for alignment purposes so that different currencies with different scale are still aligned
 * correctly.
 *
 * @type {number}
 */
Customizing.MAX_CURRENCY_SCALE = 3;

/**
 * Contains all known units with their corresponding scale
 *
 * @type {object}
 */
Customizing.UNIT = {};

/**
 * @type {object}
 */
Customizing.TIMEZONE = {};

/** Currency customizing with default values copied from CLDR
 *
 * @type {object}
 */
Customizing.CURRENCY = {
	"ADP": 0,
	"AFN": 0,
	"ALL": 0,
	"BHD": 3,
	"BIF": 0,
	"BYR": 0,
	"CLF": 4,
	"CLP": 0,
	"DEFAULT": 2,
	"DJF": 0,
	"ESP": 0,
	"GNF": 0,
	"HUF": 0,
	"IQD": 0,
	"IRR": 0,
	"ISK": 0,
	"ITL": 0,
	"JOD": 3,
	"JPY": 0,
	"KMF": 0,
	"KPW": 0,
	"KRW": 0,
	"KWD": 3,
	"LAK": 0,
	"LBP": 0,
	"LUF": 0,
	"LYD": 3,
	"MGA": 0,
	"MGF": 0,
	"MMK": 0,
	"MRO": 0,
	"OMR": 3,
	"PYG": 0,
	"RSD": 0,
	"RWF": 0,
	"SLL": 0,
	"SOS": 0,
	"STD": 0,
	"SYP": 0,
	"TMM": 0,
	"TND": 3,
	"TRL": 0,
	"TWD": 0,
	"UGX": 0,
	"UYI": 0,
	"UYW": 4,
	"VND": 0,
	"VUV": 0,
	"XAF": 0,
	"XOF": 0,
	"XPF": 0,
	"YER": 0,
	"ZMK": 0,
	"ZWD": 0
};

module.exports = Customizing;